import { CyzorAppId, CyzorAppManifest, NavigationItem, APP_REGISTRY, getAllApps, getAppManifest, getEnabledApps, getAppsByCategory, getAvailableAppIds, AppStatus, AppCategory, APP_CATEGORY_LABELS } from './appRegistry';

export type { CyzorAppId, CyzorAppManifest, NavigationItem, AppStatus, AppCategory };

export { APP_REGISTRY, getAllApps, getAppManifest, getEnabledApps, getAppsByCategory, getAvailableAppIds, APP_CATEGORY_LABELS };

export function resolveLegacyView(view: string): { app: CyzorAppId; path: string } | null {
  const mapping: Record<string, { app: CyzorAppId; path: string }> = {
    dashboard: { app: 'control', path: '/control' },
    pulse: { app: 'control', path: '/control/pulse' },
    empresas: { app: 'control', path: '/control/companies' },
    clientes: { app: 'crm', path: '/crm/customers' },
    'cliente-workspace': { app: 'crm', path: '/crm/customers' },
    produtos: { app: 'erp', path: '/erp/products' },
    'produto-workspace': { app: 'erp', path: '/erp/products' },
    projetos: { app: 'projects', path: '/projects' },
    'projeto-workspace': { app: 'projects', path: '/projects' },
    ideias: { app: 'projects', path: '/projects/ideas' },
    'ideia-workspace': { app: 'projects', path: '/projects/ideas' },
    financeiro: { app: 'erp', path: '/erp/finance' },
    documentacao: { app: 'docs', path: '/docs/documents' },
    ia: { app: 'neural', path: '/neural' },
    agenda: { app: 'control', path: '/control/calendar' },
    keep: { app: 'docs', path: '/docs' },
    'flow-builder': { app: 'automate', path: '/automate' },
    configuracoes: { app: 'control', path: '/control/settings' },
    equipe: { app: 'people', path: '/people' },
    'membro-workspace': { app: 'people', path: '/people' },
    roadmap: { app: 'projects', path: '/projects/roadmap' },
    perfil: { app: 'control', path: '/control/profile' },
    admin: { app: 'control', path: '/control/admin' },
    'admin-tenants': { app: 'control', path: '/control/admin/tenants' },
    'admin-users': { app: 'control', path: '/control/admin/users' },
    'admin-finance': { app: 'control', path: '/control/admin/finance' },
    'admin-plans': { app: 'control', path: '/control/admin/plans' },
    'admin-billing': { app: 'control', path: '/control/admin/billing' },
    'admin-settings': { app: 'control', path: '/control/admin/settings' },
    'dev-playground': { app: 'control', path: '/control/admin/playground' },
    'admin-integrations': { app: 'control', path: '/control/admin/integrations' },
    'admin-infrastructure': { app: 'control', path: '/control/admin/infrastructure' },
    'admin-logs': { app: 'control', path: '/control/admin/logs' },
    'admin-bes': { app: 'control', path: '/control/admin/bes' },
    'neural-settings': { app: 'neural', path: '/neural/settings' },
    bi: { app: 'bi', path: '/bi' },
    forms: { app: 'forms', path: '/forms' },
    sign: { app: 'sign', path: '/sign' },
  };

  return mapping[view] ?? null;
}

export function getAppNavigation(appId: CyzorAppId): NavigationItem[] {
  const manifest = getAppManifest(appId);
  return manifest?.navigation ?? [];
}

export function getAppBasePath(appId: CyzorAppId): string {
  const manifest = getAppManifest(appId);
  return manifest?.basePath ?? '/';
}

export { resolveIcon } from './iconResolver';
